import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cdc59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row footer",
  style: {"font-size":"11"}
}
const _hoisted_2 = {
  class: "col-7",
  style: {"margin-top":"8px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-power-off" }, null, -1))
const _hoisted_4 = {
  class: "fbutton",
  style: {"background-color":"#374"}
}
const _hoisted_5 = {
  href: "/changepass.html",
  class: "botonete",
  style: {"color":"white"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-key" }, null, -1))
const _hoisted_7 = {
  class: "fbutton",
  style: {"background-color":"#374"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-user" }, null, -1))


import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBar',
  props: ['title', 'user'],
  setup(__props) {

const props = __props;


const store = useStore(); // for UserName

function logout() {
	window.location.href = store.state.rootURL + "/logout.html";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(props.title), 1)
    ]),
    _createElementVNode("div", {
      class: "fbutton",
      onClick: logout
    }, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("FooterBar.CloseSession")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("FooterBar.ChangePassword")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createTextVNode(),
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("FooterBar.User")) + ":", 1),
      _createTextVNode(" " + _toDisplayString(_unref(store).state.userName), 1)
    ])
  ]))
}
}

})